module.exports = __webpack_public_path__ + "static/media/fostex-t50rp-mk3.72574ff1.jpg";